import { ENDPOINT_NAMES, endpoints } from '../../config/endpoints';
import React from 'react';
import { useData } from '@llt-frontend/react-fetch';

//

function useClientSubscriptions({ clientUid }) {
  const endpoint = endpoints.get(ENDPOINT_NAMES.clientSubscriptions, { clientUid });
  const subscriptions = useData(endpoint.path, {
    queryKey: endpoint.key,
    queryOptions: {
      enabled: Boolean(clientUid),
      select({ data } = {}) {
        return data;
      },
    },
    requestOptions: {
      maxAttempts: 1,
      onError() {
        // Do nothing, the app should fail silently
      },
    },
  });

  //
  // Results

  return React.useMemo(() => {
    function __getSubscription({ category, studentId }) {
      return subscriptions.data?.find(
        (subscription) =>
          (subscription.subscriber_uuid === studentId ||
            subscription.subscriber_type === 'client') &&
          subscription.subscription_program?.category?.includes(category)
      );
    }

    return {
      ...subscriptions,
      getSubscription: __getSubscription,
      hasSubscription(searchOptions) {
        return Boolean(__getSubscription(searchOptions));
      },
    };
  }, [subscriptions]);
}

// Exports
// -------

export default useClientSubscriptions;
